import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

import { enterStep, formatContractTypes } from '@/modules/careers/careers';
import { CareersJobFacts } from '@/modules/careers/components/careersJobFacts/CareersJobFacts';
import type { CareersJobApi } from '@/modules/careers/types';

interface CareersJobRowProps {
  job: CareersJobApi;
  to: string;
  /** The row's place in the page's rise-in stagger. */
  enterAt: number;
}

/** One job on the Careers Page; the whole row links to the job's page. */
export function CareersJobRow({ job, to, enterAt }: CareersJobRowProps) {
  const contract = formatContractTypes(job);

  return (
    <li {...enterStep(enterAt)}>
      <Link
        className="group hover:bg-sidebar focus-visible:bg-sidebar focus-visible:ring-ring/50 flex items-center gap-4 px-2 py-5 transition-colors duration-100 outline-none focus-visible:ring-[3px] active:bg-neutral-100 md:gap-6 md:px-6 md:py-6"
        to={to}
      >
        <div className="flex min-w-0 flex-1 flex-col gap-3 md:flex-row md:items-center md:gap-6">
          <div className="flex min-w-0 flex-1 flex-col gap-1">
            <h3 className="group-hover:text-primary text-lg leading-7 font-semibold tracking-[-0.02em] transition-colors duration-100 md:text-xl">
              {job.title}
            </h3>
            {contract && (
              <p className="text-muted-foreground text-sm">{contract}</p>
            )}
          </div>
          <CareersJobFacts job={job} />
        </div>
        <span
          aria-hidden
          className="group-hover:border-primary group-hover:bg-primary border-input grid size-10 shrink-0 place-items-center rounded-full border transition-[color,background-color,border-color,scale] duration-100 ease-out group-hover:text-white group-active:scale-95"
        >
          <ArrowRight className="size-[18px] transition-transform duration-150 ease-out group-hover:translate-x-0.5" />
        </span>
      </Link>
    </li>
  );
}
